import React from 'react'
import { Link } from 'react-router-dom'

function BuyButton(props) {
    return (
        <div>
            <Link to={`/buy-electricity/${props.id}`}>
                <button className='btn btn_buy'>{props.btnText}</button>
            </Link>
        </div>
    )
}

export default BuyButton
